// hooks/useJoinUser.ts
import { useMutation } from "@tanstack/react-query";
import { joinUser, AcceptInvitePayload, JoinUserResponse } from "./joinUser.api";

export const useJoinUser = () => {
  return useMutation<JoinUserResponse, Error, AcceptInvitePayload>({
    mutationFn: joinUser,
  });
};